<template>
  <div>
    <head-nav-bar title="我的订餐列表" :fixed="true" @click-left="back" />
    <div class="mt-header-nav">
      <data-list
        :api="getBookingList"
        :params="listParams"
        style="height: calc(100vh - 100px); overflow: hidden;overflow-y: auto;"
      >
        <template v-slot:item="item">
          <div class="order-item" @click="toDetail(item)">
            <div style="padding: 0 5px;" class="flex">
              <div class="flex-item">
                订单号：<span class="order-no">{{ item.No }}</span>
              </div>
              <div class="flex-item tr">
                <van-tag color="#f90">{{ item.StatusName }}</van-tag>
              </div>
            </div>
            <div class="order-info-box">
              <cell-box style="padding: 5px 0;" :column="2">
                <cell-item
                  label="联系人："
                  :value="item.Contact"
                  style="gridColumn:span 2;"
                />
                <cell-item label="就餐人数：" :value="item.PersonCount" />
                <cell-item label="联系电话：" :value="item.Phone" />
                <cell-item
                  v-if="item.CheckInTime"
                  label="订餐时间："
                  style="gridColumn:span 2;"
                  :value="item.CheckInTime"
                />
              </cell-box>
            </div>
          </div>
        </template>
      </data-list>
    </div>
  </div>
</template>

<script>
import DataList from "@/components/DataList";
import restaurantApi from "@/api/restaurant.js";
import { mapState } from "vuex";
import { CellBox, CellItem } from "@/components/cell";
import { Cell, CellGroup, Tag } from "vant";
export default {
  components: {
    DataList,
    CellBox,
    CellItem,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
  },
  data() {
    return {
      getBookingList: restaurantApi.getBookingOrderPage,
      listParams: {},
    };
  },
  computed: {
    ...mapState({
      wechatUserInfo: state => state.user.wechatUserInfo,
    }),
  },
  created() {
    this.listParams = {
      OpenId: this.wechatUserInfo.openid,
    };
  },
  methods: {
    back() {
      this.$router.push({ name: "restaurantBookingIndex" });
    },
    toDetail(item) {
      this.$router.push({
        name: "restaurantDetail",
        query: { OrderId: item.Id },
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.list-item {
  border-bottom: 0;
}
.order-item {
  margin: 8px;
  background: #fff;
  box-shadow: 1px 1px 4px #dbdbdb;
  padding: 8px 8px 0;
  /deep/.cell-item .value {
    color: #666;
  }
  .order-no {
    font-size: 15px;
    color: #1989fa;
    margin-left: 12px;
  }
  position: relative;
  .order-money {
    position: absolute;
    right: 10px;
    bottom: 6px;
    color: #f00;
    font-size: 16px;
  }
}
.order-info-box {
  // padding: 0 10px;
  /deep/.cell-item .title {
    color: #999;
  }
}
</style>
